import React from 'react';
import 'sass/loadingIcon.scss';

const LoadingIcon = () => {
	return (
		<div className="loading-body">
			<div className="loading-circle a"></div>
			<div className="loading-circle b"></div>
		</div>
	);
};

export default LoadingIcon;